export default __webpack_public_path__ + "static/media/DaviMarcos_04.77c7051c.jpg";